import * as Yup from "yup";
import {
  dateCantBeInFuture,
  dateIsBefore
} from "./validationFunctions";

export const discloseSensitiveInfoValidations = (section,languageText) => {
  // if (section.active) {
    return Yup.object().shape({
      
      sensitiveInfo: Yup.array()
        .required(
          () =>
          true &&
          languageText.ErrorChecking.ValidatorText.MissingRelease
        )


    });
  // }
}
